import axios from "axios";
import { Policy } from "../policyIssues/types";

export const downloadPolicyDocuments = async (policy: Policy) => {
  if (policy.documentId) {
    await downloadPolicyDocument(policy);
  }

  if (policy.associatedDocuments.length > 0) {
    await downloadZippedRecordableDocuments(policy);
  }
};

const downloadBlobFile = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};

const downloadPolicyDocument = async (policy: Policy) => {
  try {
    const response = await axios.get(`/api/OutstandingChecks/GetPolicyDocument?policyId=${policy.id}`, {
      responseType: "blob"
    });

    const disposition = response.headers["content-disposition"];
    const match = disposition?.match(/filename="?([^"]+)"?/);
    const filename = match?.[1];

    downloadBlobFile(new Blob([response.data], { type: "application/pdf" }), filename);
  } catch (err) {
    console.error("Download failed", err);
  }
};

const downloadZippedRecordableDocuments = async (policy: Policy) => {
  try {
    const response = await axios.get(`/api/OutstandingChecks/GetZippedRecordingDocuments?policyId=${policy.id}`, {
      responseType: "blob"
    });

    const filename = `Recorded_Docs_${policy.policyNumber}.zip`;
    downloadBlobFile(new Blob([response.data], { type: "application/zip" }), filename);
  } catch (err) {
    console.error("Download failed", err);
  }
};
